import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { formatDateDDMMYYYY } from "@/lib/format";
import { toast } from "sonner";
import { CheckCircle2, Circle } from "lucide-react";

export const GuardTasks = () => {
  const [tasks, setTasks] = useState([]);

  const load = useCallback(async () => {
    const r = await api.get("/tasks");
    setTasks(r.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const done = async (id) => {
    await api.put(`/tasks/${id}/complete`);
    toast.success("Task marked complete");
    load();
  };

  return (
    <div className="space-y-3">
      {tasks.map(t => (
        <div key={t.id} className="s-card flex items-start gap-3" data-testid={`gtask-${t.id}`}>
          <button onClick={() => !t.completed && done(t.id)} className="tap-target" style={{ minWidth: 48 }}>
            {t.completed ? <CheckCircle2 size={22} color="#2D9E5F" /> : <Circle size={22} color="#2ECAC8" />}
          </button>
          <div className="flex-1">
            <div className="flex items-center gap-2">
              <div style={{ fontSize: 14, color: "#fff", textDecoration: t.completed ? "line-through" : "none" }}>{t.title}</div>
              <StatusBadge status={t.priority} />
            </div>
            <div className="text-muted mono" style={{ fontSize: 11, marginTop: 4 }}>Due {formatDateDDMMYYYY(t.due_at)}</div>
            {t.description && <div className="text-muted" style={{ fontSize: 12, marginTop: 6 }}>{t.description}</div>}
          </div>
        </div>
      ))}
      {tasks.length === 0 && <div className="text-muted text-center" style={{ fontSize: 13 }}>No tasks assigned.</div>}
    </div>
  );
};
